module.exports = __webpack_public_path__ + "static/img/6f9a94fbd2eb9ad267d3183fd90c9eff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s_icon6.jpg
// module id = vu27
// module chunks = 1